import { createTheme } from '@mui/material/styles'

export default createTheme({
  palette: {
    type: 'dark',
    primary: {
      light: '#71a687',
      main: '#43775a',
      dark: '#164b31',
      contrastText: '#fff',
    },
    secondary: {
      light: '#a95d64',
      main: '#9edf51',
      dark: '#470314',
      contrastText: '#fff',
    },
    background: {
      default: '#282c34',
      white: '#fff',
    },
    typography: {
      allVariants: {
        color: 'white',
      },
    },
  },
})
